class ContactForm {
	constructor(element) {
		this.$form = $(element);
		this.$form.on("submit", event => this.onSubmit(event));
		this.$form.attr("data-hooked", "true");

		this.$submitButton = this.$form.find("[type=submit]");
		this.$submitButtonSpan = this.$submitButton.find("span");
		this.url = this.$form.attr("action");

		this.recaptchaSiteKey = this.$form.find("[data-recaptcha-site-key]").val();
		this.$recaptchaTokenField = this.$form.find("[name=token]");
	}

	onSubmit(event) {
		event.preventDefault();

		this.$submitButton.text("Sending...");
		this.$submitButton.prop("disabled", true);

		if(typeof grecaptcha !== "undefined") {
			grecaptcha.ready(() => {
				grecaptcha.execute(this.recaptchaSiteKey, {action: "submit"}).then(token => {
					this.$recaptchaTokenField.val(token);
					this.submit();
				});
			});
		}
		else {
			this.submit();
		}
	}

	submit() {

		const data = this.$form.serialize();

		$.post(this.url, data).always(() => {
			this.$submitButton.prop("disabled", false);
			this.$submitButton.text("Send");
		}).then(
			response => {
				if(response.success) {
					Swal.fire({
						"title": "Message sent",
						"icon": "success"
					});

					const $modal = this.$form.closest(".modal");
					if($modal.length > 0) {
						$modal.modal("hide");
					}

				}
				else {
					Swal.fire({
						"title": "Message not sent",
						"text": response.message,
						"icon": "error"
					});
				}
			},
			() => {
				// Failed
				Swal.fire({
					"title": "Message not sent",
					"text": "Please check your network connectivity and try again",
					"icon": "success"
				});
			}
		);
	}
}

$(() => {

	if(typeof google !== "undefined") {
		$("[name=location]").each((index, element) => {

			const $element = $(element);
			const autocompleteEnabled = $element.data("autocomplete");
			if(!autocompleteEnabled || autocompleteEnabled === "false") {
				return;
			}

			const $form = $element.closest("form");

			const options = {
				types: ["(regions)"],
				componentRestrictions: {
					country: "gb"
				}
			};

			const autocomplete = new google.maps.places.Autocomplete(element, options);
			autocomplete.setFields(["geometry"]);
			autocomplete.addListener("place_changed", result => {
				const place = autocomplete.getPlace();
				const geometry = place.geometry;
				const bounds = geometry.viewport;
				if(bounds !== null) {
					const sw = bounds.getSouthWest();
					const ne = bounds.getNorthEast();

					$form.find("[name=sw]").val(`${sw.lat()},${sw.lng()}`);
					$form.find("[name=ne]").val(`${ne.lat()},${ne.lng()}`);
				}
			});
		});
	}

	const contactForms = $("[data-contact-form]");
	contactForms.each((index, element) => new ContactForm(element));

	$(".submit-on-change").on("change", event => {
		const $element = $(event.currentTarget);
		const $form = $element.closest("form");
		$form.trigger("submit");
	});

	const $transactionTypeDropdowns = $("select[name=transaction_type]");
	$transactionTypeDropdowns.on("change", event => {
		const $dropdown = $(event.currentTarget);
		const transactionType = $dropdown.val();

		let optionsId = "sale-price-options"
		if(transactionType.indexOf("rent") !== -1) optionsId = "rent-price-options";

		const priceOptions = JSON.parse($(`#${optionsId}`).val());
		if(!priceOptions) return;

		const $form = $dropdown.closest("form");

		const $priceFields = $form.find("[name=min_price],[name=max_price]");
		$priceFields.find("option[value!='']").remove();

		priceOptions.forEach(option => {
			$priceFields.append(`<option value="${option.value}">${option.display}</option>`);
		});
	}).trigger("change");

	const $map = $("#map");
	const $mapContainer = $("#map-container");

	const listingsJson = $("#listings-json").val();
	let listings = [];
	if(listingsJson) {
		listings = JSON.parse(listingsJson);
	}

	let map;

	if($map.length > 0 && $mapContainer.length > 0) {

		$mapContainer.on("shown.bs.collapse", () => {
			if(map) return;

			const infoWindow = new google.maps.InfoWindow({
				content: ""
			});

			const bounds = new google.maps.LatLngBounds();

			const mapListings = listings.filter(listing => {
				if(!listing.geolocation.lat) return false;
				return listing.geolocation.lng;
			})

			mapListings.forEach(listing => bounds.extend(listing.geolocation));

			if(bounds.isEmpty() === false) {
				map = new google.maps.Map($map.get(0), {
					center: bounds.getCenter(),
					zoom: 10,
					styles: [
						{
							featureType: "poi.business",
							elementType: "labels",
							stylers: [{visibility: "off"}]
						}
					]
				});

				map.fitBounds(bounds);

				map.addListener("click", () => {
					infoWindow.close();
				});

				const getHtml = text => {
					const node = document.createElement("span");
					node.innerText = text;
					return node.innerHTML;
				};

				const markers = mapListings.map(listing => {
					const marker = new google.maps.Marker({
						position: listing.geolocation
					});
					
					const html = `<a href="${listing.url}" target="_blank"><img class="mb-2" src="${listing.image}" alt="" style="max-width: 300px; max-height: 120px; object-fit: cover;" /></a>
<div class="mb-2">
	<strong style="font-weight: bold; font-size: 1rem;">
		${listing.price}
	</strong>	
</div>

<div class="d-flex flex-row mb-2">
	<div class="flex-fill">
		${getHtml(listing.heading)}
	</div>
	<div>
		<span class="badge badge-primary">
			${getHtml(listing.status)}
		</span>
	</div>
</div>
<div class="text-center mb-2">
	<a class="btn btn-sm btn-primary" href="${listing.url}" target="_blank">
		View Details
	</a>
</div>`;

					marker.addListener("click", () => {
						infoWindow.setHeaderDisabled(true);
						infoWindow.setContent(html);
						infoWindow.open(map, marker);
						queueImpression(listing.id * 1);
					});

					return marker;
				});

				new markerClusterer.MarkerClusterer({
					markers,
					map
				})

			}

		});

	}

	$("#rights-container").on("hide.bs.collapse", event => {
		const $el = $("#rights-toggler");
		$el.find("i.fa.fa-fw.fa-chevron-up, i.fa.fa-fw.fa-chevron-down").attr("class", "fa fa-fw fa-chevron-up");
	});

	$("#rights-container").on("show.bs.collapse", event => {
		const $el = $("#rights-toggler");
		$el.find("i.fa.fa-fw.fa-chevron-up, i.fa.fa-fw.fa-chevron-down").attr("class", "fa fa-fw fa-chevron-down");
	});

	// Search results
	let impressionsTimeout = null;
	let impressionIdSet = new Set();

	const recordSearchImpressions = () => {
		$.post(`/search/impressions`, {
			ids: Array.from(impressionIdSet)
		}).done(() => {
			let seenIdsJson = sessionStorage.getItem("seenIds");
			let seenIds = [];
			if(seenIdsJson) {
				seenIds = JSON.parse(seenIdsJson);
			}
			seenIds = seenIds.concat(...impressionIdSet);
			sessionStorage.setItem("seenIds", JSON.stringify(seenIds));

			impressionIdSet.clear();

		}).fail(error => {
			console.error("Impressions not recorded.");
			console.error(error);
		});
	};

	const queueImpression = (listingId) => {
		let seenIdsJson = sessionStorage.getItem("seenIds");
		let seenIds = [];
		if(seenIdsJson) {
			seenIds = JSON.parse(seenIdsJson);
		}

		if(seenIds.indexOf(listingId * 1) !== -1) {
			return false;
		}

		impressionIdSet.add(listingId * 1);

		if(impressionsTimeout) {
			clearTimeout(impressionsTimeout);
		}

		impressionsTimeout = setTimeout(() => recordSearchImpressions(), 500);

		return true;
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if(!entry.isIntersecting) {
				return;
			}

			const el = entry.target;
			const { listingId } = el.dataset;

			queueImpression(listingId * 1);
		});
	}, {
		threshold: 0.5
	});

	const searchResults = document.querySelectorAll(".search-result");
	searchResults.forEach((element) => observer.observe(element));
});
